var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Devices"}},[_c('Devices',{ref:"devices"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }